import { ChangeDetectorRef, Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { HeaderComponent } from './layout/header/header.component';
import { FooterComponent } from './layout/footer/footer.component';
import { AsyncPipe, NgClass, NgStyle } from '@angular/common';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';
import { delay, Observable, share, Subject } from 'rxjs';
import { ApiConectateService } from './api/apiConectate';
import { ApiTokboxService } from './api/apiTokbox';
import { MultiLanguageService } from './services/multiLanguage/multiLanguage.service';
import { UtilsService } from './services/utils/utils.service';
import { StateHandlerService } from './services/state-handler/state-handler.service';
import { TranslateDirective, TranslateService } from '@ngx-translate/core';
import { SessionStorageService } from './services/session-storage/session-storage.service';
import { EnvironmentService } from './services/enviroment/environment.service';
import { environment } from '../environments/environment';

@Component({
  standalone: true,
  selector: 'app-root',
  imports: [
    TranslateDirective,
    RouterOutlet,
    HeaderComponent,
    FooterComponent,
    AsyncPipe,
    NgStyle,
    NgClass
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {
  orientationMessage = false;
  visualWindows = false;
  private headerVisibleBS: BehaviorSubject<boolean> = new BehaviorSubject(false);
  public headerVisible$: Observable<boolean> = this.headerVisibleBS
    .asObservable()
    .pipe(delay(50), share());

    /**
   * Subject para el unsubscribe de los observables al destriur el componente.
   */

  constructor(
    private readonly cdr: ChangeDetectorRef,
    private readonly apiConectateServ: ApiConectateService,
    private readonly apiTokBoxSvc: ApiTokboxService,
    private readonly utils: UtilsService,
    private readonly stateHandlerSrv: StateHandlerService,
    private readonly translate: MultiLanguageService,
      private readonly sessionStorageService: SessionStorageService,
      private readonly enviromentService: EnvironmentService
  ) {}

  public ngOnInit() {
    const params = window.location.search.split("&")[1];
    environment.isPatient && params && this.sessionStorageService.set("s", params.split("=")[1]);

    this.orientationMessage = this.utils.isMobile();
    this.stateHandlerSrv.get('intoRoomDisconnected').subscribe((res) => {
      if (typeof res === 'boolean') {
        this.headerVisibleBS.next(!res);
      }
    });
    // initialize translate service
    this.translate.initialize();
    this.detectOS();
    this.checkCloseTabsAndWindow();
    this.checkResizeScreen();
  }

  detectOS() {
    if (
      this.utils.isDesktop() ||
      !this.enviromentService.data?.features?.horizontal_mobile_message
    ) {
      this.visualWindows = true;
      this.cdr.detectChanges();
    }
  }

  checkResizeScreen() {
    window.addEventListener('resize', (e) => {
      this.detectOS();
      if (
        this.utils.isMobile() &&
        window.innerHeight > window.innerWidth &&
        window.orientation !== 90
      ) {
        (document?.querySelector('.orientation-msg-with-keyboard') as any)['style'].display = 'none';
      }
    });
  }

  checkCloseTabsAndWindow() {
    window.addEventListener('beforeunload', (e) => {
      // e = e || window.event;
      const localStorageTime: any = localStorage.getItem('videoconference_key_storagetime');

      if (localStorageTime !== null && localStorageTime !== undefined) {
        // const currentTime = new Date().getTime();
        // const timeDifference = currentTime - localStorageTime;
        localStorage.removeItem('videoconference_key_storagetime');
        this.apiConectateServ.sendUserState(false);
        this.stateHandlerSrv.get('record_state').subscribe((data) => {
          if (data?.state) {
            this.apiTokBoxSvc.StopRecord(data?.id).subscribe();
          }
        });

      } else{
        localStorage.setItem('videoconference_key_storagetime', new Date().getTime().toString());
      }
    });
  }
}
